<template>
    <left-menu-members-list-preview
            :endpoint-key="membersEndpointKey"
            :endpoint="membersEndpoint"
            :members-link="membersLink"
            :title="membersTitle"
            use-simple-link
            see-all-text="See all members"
            :see-all-link-highlighted="$route.name==='groupDetailPage-members'"
    ></left-menu-members-list-preview>
</template>

<script>
    import LeftMenuMembersListPreview from "../../../../vue/common_components/LeftMenuMembersListPreview";
    import Vue from "vue";
    import GroupResource from "../../groups/group_resource";

    export default {
        name: "GroupPageMenuMembers",
        components: {LeftMenuMembersListPreview},
        props: {
            group: Object,
        },
        computed: {
            membersEndpoint() {
                const $http = Vue.getAngularModule('$http');
                return GroupResource($http).get_random_members;
            },
            membersEndpointKey() {
                return this.group.id;
            },
            membersLink() {
                return {...this.$route, name: 'groupDetailPage-members'};
            },
            membersTitle() {
                return `Members of ${this.group.name}`;
            },
        }
    };
</script>